<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop" style="text-align: center;">For Henry and Carolyn and Buiji and Kathleen and Patty and David and Sivagami.<br/>“The best actors in the world, either for tragedy, comedy, history, pastoral, pastoral-comical, historical-pastoral, tragical-historical, tragical-comical-historical-pastoral. . . . For the law of writ and the liberty, these are the only men.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_fm01.vue?b7a53392